import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import axios from 'axios';

class User extends BasicComponent {
  getType () {
    return "User";
  }

  constructor ({id} = {}) {
    super({id});

    this.material = null;
    this.texture = null;
    this.mesh = null;
    this.scene = null;
    this.user = null;
    this.acronym = "NN";
    this.color = "#E76101"
    this.lastUpdate = 0;
    this.targetRotation = new BABYLON.Vector3();
    this.currentRotation = new BABYLON.Vector3();
    this.currentPosition = new BABYLON.Vector3();
  }

  construct (context, user) {
    console.info(`User::construct: constructing scene graph for user: ${JSON.stringify(user)}`);
    this.setSituationID(user.getCurrentSituationID());
    this.scene = window.scene;
    this.user = user;
    this.setID( user.getID() );

    const base = new BABYLON.TransformNode(user.getID(), window.scene);
    this.setRootNode(base);
    
    if (user.getPosition()) {
      base.position = user.getPosition();
    } else {
      base.position = base.absolutePosition;
      user.setPosition(base.position);
    }
    base.rotation = user.getRotation();

    const name = "User_" + user.getID();
    this.mesh = BABYLON.MeshBuilder.CreatePlane(name,
      {
        width: 3.8,
        height: 3.8,
        sideOrientation: BABYLON.Mesh.DOUBLESIDE
      }, window.scene);

    this.material = new BABYLON.StandardMaterial(name + "_material", window.scene);
    this.material.disableLighting = true;
    this.mesh.material = this.material;
    this.mesh.position = new BABYLON.Vector3(0, 0, 100);
    this.mesh.rotation = BABYLON.Vector3.Zero(); //rotation;
    this.mesh.setEnabled(false);
    this.mesh.parent = base;
    this.mesh.renderingGroupId = 1;

    this.generateTextureForUser(user);

    return this;
  }

  hexToRgbA (hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
    }
    throw new Error('Bad Hex');
  }

  generateTextureForUser (user) {
    let uc = this;
    uc.color = user.getColor();
    uc.acronym = user.getAcronym();
    axios.get(require("@/assets/user Icon.svg")).then((response) => {
      let color = "" + uc.color; 
      color = color.replace("0x", "#");
      console.log("Generating user icon for " + user.getID() + " Color: " + color + " Acronym: " + uc.acronym);
      //console.log("SVG: " + JSON.stringify(response));
      // response = response.data;
      // let svgNew = response.replace("#ACRONYM", uc.acronym); 
      let svgNew = response.data;
      // COLOR setzen... 
      svgNew = svgNew.split("#USERCOLOR").join(color); //replaceAll("#USERCOLOR", "orange");
      // svgNew = svgNew.replace("#CIRCLE_STYLE", " stroke-dasharray='20,20' ");
      // svgNew = svgNew.replace("#CIRCLE_STYLE", " ");
 
      // console.log("NEW SVG:" + svgNew)
      let encodedData = window.btoa(svgNew);
      // let decodedData = window.atob(encodedData);
      // console.log(decodedData);
      encodedData = "data:image/svg+xml;base64," + encodedData;
      const key = `${user.id}-${user.color}-texture`;
      uc.texture = BABYLON.Texture.LoadFromDataString(key, encodedData, this.scene);
      uc.material.diffuseTexture = this.texture;
      //uc.material.diffuseTexture.hasAlpha = true;
      //uc.material.diffuseTexture.useAlphaFromDiffuseTexture = true; 
      uc.material.opacityTexture = this.texture;
      uc.material.emissiveTexture = this.texture; 
      //uc.material.emissiveTexture.hasAlpha = true;
      uc.mesh.setEnabled(true);
    });
  }

  update () {
    
    let rotation = new BABYLON.Vector3(this.user.getRotation()._x,this.user.getRotation()._y,this.user.getRotation()._z)

    // console.info(`Updating user node (${this.user.acronym} id: ${this.user.id} color: ${this.user.color})`);
    let node = this.getRootNode();
    //console.log("Update " + this.user.getID() + " - " + JSON.stringify(this.user.getRotation()) );
    let camera = this.scene.activeCamera;

    let timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
    let frameTimeDifference = (timeStampInMs - this.lastUpdate) / 1000;
    //this.lastUpdate = timeStampInMs;
    if( camera ) {

      let camRotation = camera.absoluteRotation;

      if( this.user.getRotation() ) {
        
        // Check if we receive a new rotation value...
        if( this.targetRotation.x != rotation.x || this.targetRotation.y != rotation.y ||this.targetRotation.z != rotation.z ) {
          this.targetRotation = rotation;
          this.lastUpdate = timeStampInMs;
          frameTimeDifference = (timeStampInMs - this.lastUpdate) / 1000;
        } 

        let targetRotationQuaternion = BABYLON.Quaternion.FromEulerAngles( this.targetRotation.x, this.targetRotation.y, this.targetRotation.z );
        let currentRotationQuaternion = BABYLON.Quaternion.FromEulerAngles( this.currentRotation.x, this.currentRotation.y, this.currentRotation.z );
        // Compute new target rotation...
        if( frameTimeDifference >= 1.0 ) {
          currentRotationQuaternion = targetRotationQuaternion;
          this.currentRotation = this.targetRotation;
        } else {
          currentRotationQuaternion = BABYLON.Quaternion.Slerp( currentRotationQuaternion, targetRotationQuaternion, Math.min( frameTimeDifference, 1.0 ));
          this.currentRotation = currentRotationQuaternion.toEulerAngles();
        }

        let userRotation = currentRotationQuaternion;
        //let userRotation = BABYLON.Quaternion.FromEulerAngles( this.currentRotation.x, this.currentRotation.y, this.currentRotation.z );
        // We have to rotate that, due to the user looking in the wrong direction...
        //userRotation.multiplyInPlace( BABYLON.Quaternion.FromEulerAngles(0,Math.PI,0) );
        // Now let's see what the angles are...
        let diff = camRotation.multiply( BABYLON.Quaternion.Inverse( userRotation ) );
        let diffEuler = diff.toEulerAngles();
        //console.log("Difference vector is " + diffEuler.x, " / " + diffEuler.y + " / " + diffEuler.z );
        let fov = camera.fov / 2;
        let ar = this.scene.getEngine().getScreenAspectRatio();  
        let fov_y = fov * ar * 0.85;
        let fov_x = fov * 0.95;
        // If we are within the field of view, everything is fine...
        if( Math.abs(diffEuler.x) <= fov_x && Math.abs(diffEuler.y) <= fov_y ) {
          node.rotation = this.currentRotation;
          if( this.material && this.material.diffuseTexture ) {
            this.material.alpha = 1.0;
          }
        } else {
          userRotation = this.currentRotation;
          camRotation = camRotation.toEulerAngles();
          if( Math.abs(diffEuler.x) > fov_x )
            userRotation.x = camRotation.x + Math.sign(diffEuler.x) * fov_x;
          if( Math.abs(diffEuler.y) > fov_y )
            userRotation.y = camRotation.y - Math.sign(diffEuler.y) * fov_y;
          node.rotation = userRotation;
          if( this.material && this.material.diffuseTexture ) {
            this.material.alpha = 0.3;
          }
        }
      }
    } else {
      if (this.user.getPosition()) {
        let targetPosition = this.user.getPosition();
        this.currentPosition = BABYON.Vector3.Lerp( this.currentPosition, targetPosition, Math.min( frameTimeDifference, 1.0 ));
        node.position = this.currentPosition;
      }
      if (this.user.getRotation()) {
        node.rotation = rotation;
      }
    }
    this.setSituationID(this.user.getCurrentSituationID());
    if (this.user.getAcronym() !== this.acronym || this.user.getColor() !== this.color) {
      console.log("###### Acronym or Color has changed.")
      this.generateTextureForUser(this.user);
    }
  }
}

export default User;

